// Payment data: the crypto currencies we recommend (cryptoData), and the countries where the
// Centrobill and G2A checkouts are not offered.

// Checked 2026-09-18 against the NOWPayments /v1/currencies list (the provider
// that actually takes these payments) and public fee data. Ordered cheapest
// first, because the only thing this table is really for is "pick near the top".
//
// ⚠ Nano (XNO) and IOTA were removed: both were listed at the TOP as "$0.00 (no
// fees)" and NEITHER is accepted by NOWPayments — 223 currencies, no variant of
// either. The two most attractive recommendations could not be paid with.
//
// ⚠ Tron moved from "~$0.0001" to ~$0.35-$0.90. A native TRX transfer burns
// 1.37-2.73 TRX once the free daily bandwidth allowance is used, which is three
// orders of magnitude off what this table claimed, and TRX was the first
// recommendation. Ethereum likewise moved from "$0.01-$0.30" to $1-$20.
//
// Fees move with price and congestion. Re-check this table rather than trusting
// it; it sat untouched from 2026-01-30 to 2026-09-18.
export const cryptoData = [
  {
    name: 'Stellar',
    token: 'XLM',
    transactionFee: 'About $0.000004',
    transactionSpeed: '3 to 5 seconds',
  },
  {
    name: 'Ripple',
    token: 'XRP',
    transactionFee: 'About $0.00003',
    transactionSpeed: '3 to 5 seconds',
  },
  {
    name: 'Algorand',
    token: 'ALGO',
    transactionFee: 'About $0.0002',
    transactionSpeed: 'About 3 seconds',
  },
  {
    name: 'Solana',
    token: 'SOL',
    transactionFee: 'About $0.0003 to $0.001',
    transactionSpeed: 'Almost instant (1-2 seconds)',
  },
  {
    name: 'Polygon',
    token: 'MATIC',
    transactionFee: 'About $0.01',
    transactionSpeed: 'A few seconds',
  },
  {
    name: 'Tron',
    token: 'TRX',
    transactionFee: 'About $0.35 to $0.90',
    transactionSpeed: 'A few seconds',
  },
  {
    name: 'Bitcoin',
    token: 'BTC',
    transactionFee: 'About $0.80 to $5',
    transactionSpeed: '10 to 60 minutes',
  },
  {
    name: 'Ethereum',
    token: 'ETH',
    transactionFee: 'About $1 to $20',
    transactionSpeed: '15 seconds to a few minutes',
  },
]

export const centroBanCountries = []

export const g2aBanCountries = ['NZ']
